// image-upload-ui.js
window.uploadUI = (() => {
  const selectedFiles = [];
  const uploadedFiles = new Set();

  function initImageUploadUI(dropAreaId, fileInputId, previewContainerId) {
    const dropArea = document.getElementById(dropAreaId);
    const fileInput = document.getElementById(fileInputId);
    const previewContainer = document.getElementById(previewContainerId);

    if (!dropArea || !fileInput || !previewContainer) return;

    function handleFiles(files) {
      [...files].forEach((file) => {
        if (!file.type.startsWith("image/")) return;

        const uniqueKey = `${file.name}_${file.size}`;
        if (uploadedFiles.has(uniqueKey)) {
          alert("This image has already been uploaded.");
          return;
        }

        uploadedFiles.add(uniqueKey);
        selectedFiles.push(file);

        const reader = new FileReader();

        const previewBox = document.createElement("div");
        previewBox.classList.add("preview-box");

        const progressBar = document.createElement("div");
        progressBar.classList.add("upload-progress");
        progressBar.style.width = "0%";

        const progressWrapper = document.createElement("div");
        progressWrapper.classList.add("progress-wrapper");
        progressWrapper.appendChild(progressBar);

        previewBox.appendChild(progressWrapper);
        previewContainer.appendChild(previewBox);

        let progress = 0;
        const fakeProgress = setInterval(() => {
          progress += 10;
          progressBar.style.width = `${progress}%`;
          if (progress >= 90) clearInterval(fakeProgress);
        }, 50);

        reader.onload = () => {
          clearInterval(fakeProgress);
          progressBar.style.width = "100%";

          const img = document.createElement("img");
          img.src = reader.result;

          const removeBtn = document.createElement("span");
          removeBtn.classList.add("remove-image");
          removeBtn.innerHTML = "<span class='icon icon-cross'></span>";
          removeBtn.onclick = () => {
            previewBox.remove();
            uploadedFiles.delete(uniqueKey);
            const index = selectedFiles.findIndex(
              (f) => `${f.name}_${f.size}` === uniqueKey
            );
            if (index !== -1) selectedFiles.splice(index, 1);
          };

          setTimeout(() => {
            previewBox.innerHTML = "";
            previewBox.appendChild(img);
            previewBox.appendChild(removeBtn);
          }, 300);
        };

        reader.readAsDataURL(file);
      });
    }

    fileInput.addEventListener("change", (e) => {
      handleFiles(e.target.files);
      fileInput.value = "";
    });

    dropArea.addEventListener("dragover", (e) => {
      e.preventDefault();
      dropArea.classList.add("hover");
    });

    dropArea.addEventListener("dragleave", () => {
      dropArea.classList.remove("hover");
    });

    dropArea.addEventListener("drop", (e) => {
      e.preventDefault();
      dropArea.classList.remove("hover");
      if (e.dataTransfer.files.length) {
        handleFiles(e.dataTransfer.files);
      }
    });

    dropArea.addEventListener("click", () => fileInput.click());
  }

  return {
    init: initImageUploadUI,
    getSelectedFiles: () => selectedFiles,
    clearAll: () => {
      selectedFiles.length = 0;
      uploadedFiles.clear();
    },
  };
})();
